import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err));

 if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then((registration) => {
      //console.log('Service Worker registrado con alcance:', registration.scope);
    }).catch((err) => {
      //console.error('Error al registrar el Service Worker:', err);
    });
}